import React from "react";
import { FiArrowRight, FiArrowUpRight } from "react-icons/fi";
import { roleAccess } from "helpers/RolesPermission";
import { USER_ROLE, PARTICIPANT_PROFILE_TABS } from "Constants/constant";
import CircularLoader from "../CircularLoader/CircularLoader";
import SupportPlanItem from "./SupportPlanItem";
import { classNames, formatDateIntoDMYToDisplay } from "Utils/utils";
import { PERMISSION_KEYS, PERMISSION_KEYS_CHILDREN } from "store/constants";

const SupportPlan = (props) => {
  const {
    participantsInfo,
    setToggleState,
    supportPlanData,
    isLoading,
    viewInitialAssesmentForm,
    addInitialAssesmentForm,
    initialAssessmentEditEnabled = true,
    initialAssessmentAddEnabled = true,
  } = props;

  const initialAssessmentNavDisabled =
    supportPlanData !== null
      ? !initialAssessmentEditEnabled
      : !initialAssessmentAddEnabled;

  const validInputTypesForSupportPlan = [
    "text",
    "number",
    "date",
    "email",
    "checkbox",
    "select",
    "radio",
    "textarea",
    "phone",
    "address",
    "file",
    //  "signature",
    //  "table"
  ];

  return (
    <>
      <div className='min-h-full'>
        {isLoading ? (
          <CircularLoader
            classes='flex justify-center items-center'
            classloader='loader-l'
          />
        ) : (
          <div className='w-full'>
            <div className='bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden'>
              {/* Compact Header */}
              <div className='bg-gradient px-4 sm:px-5 py-3.5 sm:py-4'>
                <div>
                  <h2 className='text-lg sm:text-xl font-bold text-white'>
                    Support Plan
                  </h2>
                  <p className='text-xs text-blue-100 mt-0.5'>
                    Comprehensive support plan information
                  </p>
                </div>
              </div>

              <div className='p-3 sm:p-4'>
                <dl className='grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3'>
                  {roleAccess(
                    [],
                    PERMISSION_KEYS.PARTICIPANT,
                    PERMISSION_KEYS_CHILDREN.PARTICIPANT.DOB
                  ) && (
                    <div className='bg-gray-50 rounded-lg p-3 border border-gray-100 hover:border-gray-200 transition-colors'>
                      <dt className='text-[10px] font-semibold text-gray-500 tracking-wide mb-1.5'>
                        Date of Birth
                      </dt>
                      <dd
                        onClick={() => {
                          if (
                            !roleAccess([USER_ROLE.Sp_Standard_User]) &&
                            roleAccess(
                              [],
                              PERMISSION_KEYS.PARTICIPANT,
                              PERMISSION_KEYS_CHILDREN.PARTICIPANT.SETTING.SHOW
                            )
                          ) {
                            const settingsTab = PARTICIPANT_PROFILE_TABS.find(tab => tab.id === 13);
                            if (settingsTab) {
                              setToggleState(settingsTab);
                            }
                          }
                        }}
                        className={classNames(
                          "text-xs font-medium flex items-center space-x-2",
                          !roleAccess([USER_ROLE.Sp_Standard_User]) &&
                            roleAccess(
                              [],
                              PERMISSION_KEYS.PARTICIPANT,
                              PERMISSION_KEYS_CHILDREN.PARTICIPANT.SETTING.SHOW
                            ) &&
                            "cursor-pointer hover:text-blue-600 transition-colors",
                          participantsInfo && participantsInfo.dob
                            ? "text-gray-900"
                            : "text-red-500"
                        )}
                      >
                        <span>
                          {participantsInfo && participantsInfo.dob
                            ? formatDateIntoDMYToDisplay(participantsInfo.dob)
                            : roleAccess([USER_ROLE.Sp_Standard_User])
                            ? "No Data found!"
                            : "Add Information"}
                        </span>
                        {!roleAccess(USER_ROLE.Sp_Standard_User) &&
                          participantsInfo &&
                          !participantsInfo.dob && (
                            <span className='text-blue-600'>
                              <FiArrowUpRight className="h-3 w-3" />
                            </span>
                          )}
                      </dd>
                    </div>
                  )}
                  {supportPlanData &&
                    supportPlanData?.support_plan_data &&
                    supportPlanData.support_plan_data.length > 0 &&
                    supportPlanData.support_plan_data
                      .filter((inputType) =>
                        validInputTypesForSupportPlan.includes(inputType.type)
                      )
                      .map((x, index) => (
                        <SupportPlanItem
                          form_uuid={supportPlanData.form_data_uuid}
                          item={x}
                          key={index}
                          viewInitialAssesmentForm={viewInitialAssesmentForm}
                        />
                      ))}

                  {/* Action Button */}
                  <div className='sm:col-span-2 xl:col-span-3 print:hidden mt-4'>
                    {!supportPlanData &&
                    roleAccess([USER_ROLE.Sp_Standard_User]) ? (
                      <div className='text-center text-xs font-medium text-red-500 bg-red-50 rounded-lg p-3 border border-red-200'>
                        <span>No Data Found!</span>
                      </div>
                    ) : (
                      <button
                        type='button'
                        disabled={initialAssessmentNavDisabled}
                        onClick={() => {
                          if (initialAssessmentNavDisabled) return;
                          supportPlanData !== null
                            ? viewInitialAssesmentForm(
                                supportPlanData.form_data_uuid
                              )
                            : addInitialAssesmentForm();
                        }}
                        role='button'
                        tabIndex={0}
                        title={
                          initialAssessmentNavDisabled
                            ? "You do not have permission to edit this form"
                            : undefined
                        }
                        className={classNames(
                          "w-full text-left text-xs font-medium flex items-center justify-between space-x-2 rounded-lg p-3 border transition-all",
                          initialAssessmentNavDisabled
                            ? "text-gray-400 bg-gray-50 border-gray-200 cursor-not-allowed"
                            : "text-blue-600 hover:text-blue-700 bg-blue-50 hover:bg-blue-100 border-blue-200"
                        )}
                      >
                        <span>
                          {supportPlanData !== null
                            ? "To edit Information on Support Plan, Please edit initial assessment form"
                            : "To add Information on Support Plan, Please submit initial assessment form"}
                        </span>
                        <span
                          className={classNames(
                            "flex-shrink-0",
                            initialAssessmentNavDisabled
                              ? "text-gray-400"
                              : "text-blue-600"
                          )}
                        >
                          <FiArrowRight className="h-4 w-4" />
                        </span>
                      </button>
                    )}
                  </div>

                  {/* Metadata */}
                  {supportPlanData && (
                    <div className='sm:col-span-2 xl:col-span-3 mt-4 pt-4 border-t border-gray-200'>
                      <div className='grid grid-cols-1 sm:grid-cols-2 gap-3'>
                        <div className='bg-gray-50 rounded-lg p-3 border border-gray-100'>
                          <dt className='text-[10px] font-semibold text-gray-500 tracking-wide mb-1'>
                            Last Support Plan update
                          </dt>
                          <dd className='text-xs font-medium text-gray-900'>
                            {supportPlanData && supportPlanData.last_updated ? (
                              formatDateIntoDMYToDisplay(
                                supportPlanData.last_updated
                              )
                            ) : roleAccess([USER_ROLE.Sp_Standard_User]) ? (
                              <span className='text-red-500'>No Data found!</span>
                            ) : (
                              <span
                                onClick={() =>
                                  supportPlanData !== null
                                    ? viewInitialAssesmentForm(
                                        supportPlanData.form_data_uuid
                                      )
                                    : addInitialAssesmentForm()
                                }
                                tabIndex={0}
                                role='button'
                                className='cursor-pointer text-blue-600 hover:text-blue-700 flex items-center gap-1'
                              >
                                Add Information
                                <FiArrowUpRight className="h-3 w-3" />
                              </span>
                            )}
                          </dd>
                        </div>
                        <div className='bg-gray-50 rounded-lg p-3 border border-gray-100'>
                          <dt className='text-[10px] font-semibold text-gray-500 tracking-wide mb-1'>
                            Last update by
                          </dt>
                          <dd className='text-xs font-medium text-gray-900'>
                            {supportPlanData &&
                            (supportPlanData.hasOwnProperty("updated_by") &&
                            supportPlanData.updated_by ? (
                              supportPlanData.updated_by
                            ) : supportPlanData.created_by ? (
                              supportPlanData.created_by
                            ) : roleAccess([USER_ROLE.Sp_Standard_User]) ? (
                              <span className='text-red-500'>No Data found!</span>
                            ) : (
                              <span
                                onClick={viewInitialAssesmentForm}
                                tabIndex={0}
                                role='button'
                                className='cursor-pointer text-blue-600 hover:text-blue-700 flex items-center gap-1'
                              >
                                Add Information
                                <FiArrowUpRight className="h-3 w-3" />
                              </span>
                            ))}
                          </dd>
                        </div>
                      </div>
                    </div>
                  )}
                </dl>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default SupportPlan;
